export const Cost = ({title, cost}) => {
    const isTotal = title === "Total" ? true : false
    return (
        <div className="is-flex is-justify-content-space-between" style={{margin: "0 .5rem 0 .5rem"}}>
            <span style={{fontWeight: isTotal && "bold", fontSize: ".8rem"}}>{title}</span>
            <span style={{fontWeight: isTotal && "bold", fontSize: ".8rem"}}>{parseFloat(cost).toFixed(2)}</span>
        </div>
    )
}